export const MORNING_REPORT_PATH = "/dashboard/morning-report";

/** MorningReport's own domain, served by the same site as HealthDesk. */
export const isMorningReportDomain = (hostname = window.location.hostname) =>
  ["morningreport.si", "www.morningreport.si"].includes(hostname);

export const morningReportSessionPath = (sessionId) =>
  `${MORNING_REPORT_PATH}/${encodeURIComponent(sessionId)}`;

export const CASE_MAKER_PATH = "/dashboard/admin/morning-report-cases";

export const caseMakerEditorPath = (caseId) =>
  `${CASE_MAKER_PATH}/${encodeURIComponent(caseId)}`;

/** Where a guest (no account) plays today's case, outside the dashboard. */
export const MORNING_REPORT_GUEST_PATH = "/morning-report/play";

export const morningReportGuestSessionPath = (sessionId) =>
  `${MORNING_REPORT_GUEST_PATH}/${encodeURIComponent(sessionId)}`;
